export enum TicketTipo {
    INFRAESTRUCTURA='INFRAESTRUCTURA', 
    MEJORA='MEJORA',
    PERFIL='PERFIL',
    CAPACITACION='CAPACITACIÓN'
}
